import React from 'react';
import { connect } from 'react-redux';
import Translate from 'translate';
import { Form } from 'react-form';
import moment from 'moment';
import Table from 'components/HTMLElements/Table/Custom';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import UserService from 'services/UserService';
import ReportService from 'services/ReportService';
import { FormGroup } from 'components/FormElements';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { CSVLink } from "react-csv";

class ActivityByUserReport extends React.Component {
  constructor(props) {
    super(props);
     
    this.date = new Date();
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.lastDay = `${this.date.getFullYear()}-${_.padStart(this.date.getMonth()+1,2,'0')}-${_.padStart(this.getDaysInMonth ( this.date.getMonth()+1 , this.date.getFullYear(),2,'0'))}`;
    this.currentDay = moment().format('YYYY-MM-DD')

    this.nodes = [

    ];
    this.state = {
      checked: [this.currentDay],
      checkedSources: [ 'facebook','twitter','phone', 'email','chat','walk_in'],
      expanded: [],
      expandedSources: [],
      data: [],
      dataExport: [],
      dataExportCSV: [ ['',''],['','']],
      user: [],
      sources: [ 
        {
          value: '',
          label:'All',
          icon :'',
          children: [
            {value:'facebook',label:'face...' , icon :''},
            {value:'twitter',label:'twitter', icon :''},
            {value:'phone',label:'phone', icon :''},
            {value:'email',label:'email', icon :''},
            {value:'chat',label:'chat', icon :''},
            {value:'walk_in',label:'walkin', icon :''},
          ]
        }

      ],
      dateFrom: this.firstDay,

      deleteModalOpened: false,
      value: 0
    };
    this.download = '';
    this.search = {};
    this.getData = this.getData.bind(this);
  }
  capitalizeFirstLetter(string) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  formatDataExport(values, data){
    //let sourcesChecked = this.state.checkedSources;
    //const { data } = this.state;
    const {
      chatActive
    } = this.props;

    let info = data;
    let filters = [];
    let infor = [];
    let columns = [];

    filters = _.indexOf(values, 'facebook') !== -1 ? [...filters, 'FB_NO_CREATED', 'FB_NO_REPLIED_TO', 'FB_NO_DISMISSED'] : [...filters];
    filters = _.indexOf(values, 'twitter') !== -1 ? [...filters, 'TW_NO_CREATED', 'TW_NO_REPLIED_TO', 'TW_NO_DISMISSED'] : [...filters];
    filters = _.indexOf(values, 'phone') !== -1 ? [...filters, 'PHONE_NO_CREATED', 'PHONE_NO_REPLIED_TO', 'PHONE_NO_DISMISSED' ] : [...filters];
    filters = _.indexOf(values, 'email') !== -1 ? [...filters, 'EMAIL_NO_CREATED', 'EMAIL_NO_REPLIED_TO', 'EMAIL_NO_DISMISSED'] : [...filters];
    if(chatActive){
      filters = _.indexOf(values, 'chat') !== -1  ? [...filters, 'CHAT_NO_CREATED', 'CHAT_NO_REPLIED_TO', 'CHAT_NO_DISMISSED'] : [...filters];
    }
    filters = _.indexOf(values, 'walk_in') !== -1 ? [...filters, 'WALK_IN_NO_CREATED', 'WALK_IN_REPLIED_TO', 'WALK_IN_DISMISSED'] : [...filters];
    //const filters = ['EMAIL_NO_CREATED','EMAIL_NO_REPLIED_TO', 'FB_NO_CREATED', 'FB_NO_REPLIED_TO', 'PHONE_NO_CREATED', 'PHONE_NO_REPLIED_TO', 'TW_NO_CREATED', 'TW_NO_REPLIED_TO', 'CHAT_NO_CREATED', 'CHAT_NO_REPLIED_TO'];
    const base = _.map(info, (item, index) => { 
      let aux = {username: item['username']};
      Object.entries(item).forEach(([key, value]) => {
        if (filters.indexOf(key) !== -1) {
          aux[key] = parseInt(value);
        }
      })
      return aux;
    });
    if (base.length > 0){
      columns = _.map(base[0], (item, index) => index === 'username' ? 'SYS USER' : index.replace(/_/g,' ') );
    }

    if (base.length > 0){
      infor = _.map(base, (item, index) => {
        return item ? Object.values(item) : '';
      });
    }

    if(base.length == 0){
      columns = ["SYS USER", "EMAIL NO CREATED", "EMAIL NO REPLIED TO", "EMAIL NO DISMISSED", "FB NO CREATED", "FB NO REPLIED TO", "FB NO DISMISSED", "PHONE NO CREATED", "PHONE NO REPLIED TO", "PHONE NO DISMISSED", "TW NO CREATED", "TW NO REPLIED TO", "TW NO DISMISSED", "WALK IN NO CREATED", "WALK IN NO REPLIED TO", "WALK IN NO DISMISSED"]
    }

    let global = _.map(base, item => {
      let noCreated = 0;
      let noReplied = 0;
      let noDismissed = 0;
      Object.entries(item).forEach(([key, value]) => {
        if(key.includes('NO_CREATED')){
          noCreated += parseInt(value);
        }
        if(key.includes('REPLIED_TO')){
          noReplied += parseInt(value);
        }
        if(key.includes('DISMISSED')){
          noDismissed += parseInt(value);
        }
      })
      return [noCreated, noReplied, noDismissed];
    });

    columns = [...columns, 'GRAND TOTAL NO CREATED', 'GRAND TOTAL NO REPLIED TO', 'GRAND TOTAL NO DISMISSED'];
    columns = _.map(columns, item => {
      let string = this.capitalizeFirstLetter(item)
      return string.replace('no', 'No.');
    });

    let results = _.map(infor, (item, index) => {
      return [...item, ...global[index]];
    });
    
    if(results.length == 0){
      results = [["","","","","","","","","","","","","","","",""]]
    }

    const result = [{
      "xSteps": 0,
      "ySteps": 0,
      "columns": columns,
      "data": results
    }];
    console.log('result', result);
    this.setState({
      dataExport: result,
      dataExportCSV: [columns, ...results]
    })

    return ( result, results );
  }

  colums(){
    const {
      chatActive
    } = this.props;
    //const chatActive =true;
    const fbFactor = _.indexOf(this.state.checkedSources, 'facebook') === -1 ? 0 : 1;
    const twFactor = _.indexOf(this.state.checkedSources, 'twitter') === -1 ? 0 : 1;
    const phoFactor = _.indexOf(this.state.checkedSources, 'phone') === -1 ? 0 : 1;
    const emailFactor = _.indexOf(this.state.checkedSources, 'email') === -1 ? 0 : 1;
    const chatFactor = _.indexOf(this.state.checkedSources, 'chat') === -1 || !chatActive ? 0 : 1;
    const walkInFactor = _.indexOf(this.state.checkedSources, 'walk_in') === -1 ? 0 : 1;

    let WIDTH = 60;
    let nuCols = (fbFactor + twFactor + phoFactor + emailFactor + chatFactor + walkInFactor + 1) * 2;
    const delta = parseInt(WIDTH / nuCols);

    WIDTH = 880 / nuCols;
    
    let col = [
      {
        Header: (
          <div className="text-center">
            <Translate id="report.sysUser" />{" "}
          </div>
        ),
        accessor: "username",
        style: { borderRight: "1px solid" },
        Cell: (props) => <div className="text-center"> {props.value} </div>,
        maxWidth: WIDTH + 27,
      },
      {
        Header: <div className="text-center">Email</div>,

        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "EMAIL_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "EMAIL_NO_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "EMAIL_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: <div className="text-center">Facebook</div>,
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "FB_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "FB_NO_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "FB_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: <div className="text-center">Phone</div>,
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "PHONE_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "PHONE_NO_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "PHONE_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: <div className="text-center">Twitter</div>,
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "TW_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "TW_NO_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "TW_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: <div className="text-center">Chat</div>,
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "CHAT_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "CHAT_NO_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "CHAT_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: <div className="text-center">Walk In</div>,
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "WALK_IN_NO_CREATED",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "WALK_IN_REPLIED_TO",
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "WALK_IN_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => <div className="text-center"> {props.value} </div>,
          },
        ],
      },
      {
        Header: (
          <div className="text-center">
            <Translate id="report.grandTotal" />
          </div>
        ),
        columns: [
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_CREATED" />
              </div>
            ),
            accessor: "TW_NO_CREATED",
            Cell: (props) => (
              <div className="text-center">
                {" "}
                {parseInt(props.value) * twFactor +
                  parseInt(props.original.PHONE_NO_CREATED) * phoFactor +
                  parseInt(props.original.FB_NO_CREATED) * fbFactor +
                  parseInt(props.original.EMAIL_NO_CREATED) * emailFactor +
                  parseInt(_.get(props, "original.CHAT_NO_CREATED", 0)) * chatFactor
                  +  parseInt(props.original.WALK_IN_NO_CREATED) * walkInFactor 
                    }{" "}
              </div>
            ),
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.NO_REPLIED_TO" />
              </div>
            ),
            accessor: "TW_NO_REPLIED_TO",
            Cell: (props) => (
              <div className="text-center">
                {" "}
                {parseInt(props.value) * twFactor +
                  parseInt(props.original.PHONE_NO_REPLIED_TO) * phoFactor +
                  parseInt(props.original.FB_NO_REPLIED_TO) * fbFactor +
                  parseInt(props.original.EMAIL_NO_REPLIED_TO) * emailFactor +
                  parseInt(_.get(props, "original.CHAT_NO_REPLIED_TO", 0)) *
                    chatFactor
                  +  parseInt(props.original.WALK_IN_REPLIED_TO) * walkInFactor   
                    }{" "}
              </div>
            ),
          },
          {
            width: WIDTH,
            Header: (
              <div className="text-center">
                <Translate id="report.dismissed" />
              </div>
            ),
            accessor: "TW_NO_DISMISSED",
            style: { borderRight: "1px solid" },
            Cell: (props) => (
              <div className="text-center">
                {" "}
                {parseInt(props.value) * twFactor +
                  parseInt(props.original.PHONE_NO_DISMISSED) * phoFactor +
                  parseInt(props.original.FB_NO_DISMISSED) * fbFactor +
                  parseInt(props.original.EMAIL_NO_DISMISSED) * emailFactor +
                  parseInt(_.get(props, "original.CHAT_NO_DISMISSED", 0)) *
                    chatFactor
                    +  parseInt(props.original.WALK_IN_DISMISSED) * walkInFactor 
                    }{" "}
              </div>
            ),
          },
        ],
      },
    ];

    let newCol = [];
    _.map(col, (val, idx) => {
      if (emailFactor !== 0 && idx === 1) newCol.push(val);
      if (fbFactor !== 0 && idx === 2) newCol.push(val);
      if (phoFactor !== 0 && idx === 3) newCol.push(val);
      if (twFactor !== 0 && idx === 4) newCol.push(val);
      if (chatFactor !== 0 && idx === 5 && chatActive) newCol.push(val);
      if (walkInFactor !== 0 && idx === 6) newCol.push(val);
      if (idx === 0 || idx === 7) newCol.push(val);
    });
    return newCol
  }
  componentDidMount() {
    const {chatActive} = this.props;
    //const chatActive =true;
    let children = [
      {value:'facebook',label:'face...' , icon :''},
      {value:'twitter',label:'twitter', icon :''},
      {value:'phone',label:'phone', icon :''},
      {value:'email',label:'email', icon :''},
      {value:'walk_in',label:'walkin', icon :''},
    ];

    if (chatActive){
      children.push( {value:'chat',label:'chat', icon :''})
    }
      this.setState({

        sources: [ 
          {
            value: '',
            label:'All',
            icon :'',
            children: children
          }

        ]
      })

    // this.getData(this.params);
    this.getReport(this.params);
  }
  getData(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);

    UserService.getUsers().then(response => {
      //toggleLoading(false);

      if (response.data) {
        this.setState({
          user: response.data.data
        });
      }
    });
  }

  getDaysInMonth(m, y) {
    return m===2 ? y & 3 || !(y%25) && y & 15 ? 28 : 29 : 30 + (m+(m>>3)&1);
  }
  createDateRange(fechas) {
    const rangos = [];
  
    for (let i = 0; i < fechas.length; i++) {
      const fechaActual = fechas[i];
  
      if (!rangos.length) {
        rangos.push({ from: fechaActual.from, till: fechaActual.till });
        continue;
      }
      const ultimoRango = rangos[rangos.length - 1];
  
      if (new Date(ultimoRango.till).getTime() === new Date(fechaActual.from).getTime() - 86400000) {
        ultimoRango.till = fechaActual.till;
      } else {
        rangos.push({ from: fechaActual.from, till: fechaActual.till });
      }
    }
  
    return rangos;
  }

  getReport(params) {
    const {
      isLoading,
      toggleLoading
    } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);
    //const apiParams = {
    // userId: this.state.value,
    let apiParams = [];
    let datesGroup = [];
    _.map(this.state.checked, function (toDate) {
      const year = parseInt(moment(toDate).format('yyyy'));
      const month = parseInt(moment(toDate).format('MM'));
      const beginDate = moment(`${year}-${_.padStart(month, 2, '0')}-01`).format('YYYY-MM-DD')
      apiParams.push({
        from: toDate,
        till: toDate,
      });

    });
    apiParams= this.createDateRange(apiParams);
    
    ReportService.getReportsActivityByUser(apiParams, this.download).then(response => {


      if (this.download !== '') {
        toggleLoading(false);
        window.location.href = response.data.uri;
      } else {

        //let datefrom = response.data.dateRange['from'];
        const yearFrom = 2020; // parseInt ( datefrom.substr(0, 4) );
        const monthFrom = 10; // parseInt ( datefrom.substr(5, 2) );

        const yearTo = parseInt(moment().format('yyyy'));
        const monthTo = parseInt(moment().format('MM'));
        let years = [];
        let lastDay = 30;
        let days = [];
        for (var year = yearFrom; year <= yearTo; year++) {
          let months = [];

          if (year === yearTo && yearTo === yearFrom) {
            for (var month = monthFrom; month <= monthTo; month++) {
              lastDay = this.getDaysInMonth(month, year);
              days = [];
              for (var day = 1; day <= lastDay; day++) {
                days.push({
                  value: `${year}-${_.padStart(month,2,'0')}-${_.padStart(day,2,'0')}`,
                  label: `${_.padStart(day,2,'0')}`,
                  icon: ''
                })
              }
              months.push({
                value: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMMYYYY'),
                label: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMM'),
                children: [...days],
                icon: ''
              }, );

            }
          } else if (year === yearTo && yearTo !== yearFrom) {

            for (var month = 1; month <= monthTo; month++) {
              lastDay = this.getDaysInMonth(month, year);
              days = [];

              for (var day = 1; day <= lastDay; day++) {
                days.push({
                  value: `${year}-${_.padStart(month,2,'0')}-${_.padStart(day,2,'0')}`,
                  label: `${_.padStart(day,2,'0')}`,
                  icon: ''
                })
              }

              months.push({
                value: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMMYYYY'),
                label: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMM'),
                children: [...days],
                icon: ''
              }, )
            }

          } else if (year === yearFrom && yearTo !== yearFrom) {
            for (var month = monthFrom; month <= 12; month++) {
              lastDay = this.getDaysInMonth(month, year);
              days = [];
              for (var day = 1; day <= lastDay; day++) {
                days.push({
                  value: `${year}-${_.padStart(month,2,'0')}-${_.padStart(day,2,'0')}`,
                  label: `${_.padStart(day,2,'0')}`,
                  icon: ''
                })
              }
              months.push({
                value: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMMYYYY'),
                label: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMM'),
                children: [...days],
                icon: ''
              }, );

            }
          } else {
            for (var month = 1; month <= 12; month++) {
              lastDay = this.getDaysInMonth(month, year);
              days = [];
              for (var day = 1; day <= lastDay; day++) {
                days.push({
                  //value: `${year}-${_.padStart(month,2,'0')}`,
                  value: `${year}-${_.padStart(month,2,'0')}-${_.padStart(day,2,'0')}`,
                  label: `${_.padStart(day,2,'0')}`,
                  icon: ''
                })
              }
              months.push({
                value: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMMYYYY'),
                label: moment(`${year}-${_.padStart(month,2,'0')}-01`).format('MMM'),
                children: [...days],
                icon: ''
              }, )
            }
          }
          years.push({
            value: year,
            label: year,
            children: months,
            icon: ''
          });
        }
        this.nodes = years;
        toggleLoading(false);
        const { data1, data2 } = this.formatDataExport(this.state.checkedSources, response.data.data);
        this.setState({
          data: response.data.data,
          dataExport: data1,
        });

      }
    });
  }

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  handleDateChangeDateFrom = e => {
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    this.setState({ dateTo: e });
  };
  handleDateCheck = checked => {
    this.setState({ checked }); 
  }

  handleSourceCheck = checkedSources => {
    this.setState({ checkedSources });
  }

  handleExportData = (values) =>{
    const {data} = this.state;
    this.setState({ dataExport: this.formatDataExport(values, data) });
  } 
  submitForm = data => {
    
    this.search = data;
    //this.getReport(this.params);
  };

  render() {
    const { value, data, dataExport,dataExportCSV, dateFrom, dateTo, user } = this.state;
    return (
      
        <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <h4>
            <Translate id="report.activityByUserReport" />
            
          </h4>
        </div>
        <div className="box-body">
        <div className="row p-0">

          <div className="col-md-2">
            <div className="box box-default">

              <div className="box-body">
             
                    <Form onSubmit={this.submitForm}>
                      {({ submitForm }) => (
                        <form onSubmit={submitForm} >
                          <FormGroup >
                          <label className={'MuiFormLabel-root MuiInputLabel-shrink'} style={{marginBottom:'0rem',color:'rgba(0, 0, 0, 0.54)',fontSize:'11px'}}><Translate id="report.year.month"/></label>

                          <CheckboxTree
                          nodes={this.nodes}
                          checked={this.state.checked}
                          expanded={this.state.expanded}
                          onCheck={this.handleDateCheck}
                          onExpand={expanded => this.setState({ expanded })}
                          />
                          </FormGroup>
                          <hr/>
                          <FormGroup >
                          <label className={'MuiFormLabel-root MuiInputLabel-shrink'} style={{marginBottom:'0rem',color:'rgba(0, 0, 0, 0.54)',fontSize:'11px'}}><Translate id="report.channel"/></label>

                          <CheckboxTree
                          nodes={this.state.sources}
                          checked={this.state.checkedSources}
                          expanded={this.state.expandedSources}
                          onCheck={(values) => { this.handleSourceCheck(values); this.handleExportData(values);}}
                          onExpand={expandedSources => this.setState({ expandedSources })}
                          />
                          </FormGroup>
                          <hr/>
                          <div >
                            <button
                              style={{  float: 'right' }}
                              type="submit"
                              className="btn btn-info mr-2 px-3"
                              onClick={() => {
                                this.search = {};
                                this.download = '';
                                this.getReport(
                                  value,
                                  moment(dateFrom).format('DD-MM-YYYY'),
                                  moment(dateTo).format('DD-MM-YYYY')
                                );
                              }}
                            >
                              <i className="fa fa-search pointer" />
                            </button>
                          </div>

                          <div >


                            
                          </div>
                        </form>
                      )}
                    </Form>
              </div>
            </div>
          </div>

          <div className="col-md-10">

          
                <div className="box box-default">
                 
                  <div>
 
                    <div className="box-body">
                      <div style={{  float:'right' }}>
                      <CSVLink data={dataExportCSV} filename="ActivityByUser.csv" className="btn btn-xs btn-info" separator={";"}>
                        <i className="fa fa-download" />
                      </CSVLink>
                      {
                        // <ExcelFile 
                        //  element={(
                        //</div>  <button className="btn btn-xs btn-info">
                        //   
                        //  </button>
                        // )}
                        // filename="Download"
                        // >
                        //</div>  <ExcelSheet dataSet={dataExport} name="Report"/>
                        //</ExcelFile>
                      }
                      </div>
                      <Table  
                        className="app-table-report"
                        style={{ width: '100%' }}
                        data={data}
                        columns={this.colums()}
                      />
                    </div>
                  </div>
                </div>
            </div>               
        </div>
        </div>
       </div>
      
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.settings.isLoading,
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: message => {
    dispatch(toggleAlertError(message));
  },
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityByUserReport);




// WEBPACK FOOTER //
// ./routes/app/routes/reports/ActivityByUserReport/index.js